module.exports = __webpack_public_path__ + "img/go-forward-button.e62eab75.svg";